module.exports = __webpack_public_path__ + "static/media/monthly-payment.ae542c57.png";